import { render, staticRenderFns } from "./SynthesisView.vue?vue&type=template&id=4c81145a&"
import script from "./SynthesisView.vue?vue&type=script&lang=js&"
export * from "./SynthesisView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports